<script setup lang="ts">
import type { AuthProviderDefinition } from '#layers/access/types/auth-providers/define';
import type { WireAuthProviderAdminRecord } from '#layers/access/utils/auth-providers/wire';
import { computed } from 'vue';
import { useColorMode } from '#imports';
import { resolveProviderVisuals } from '#layers/access/utils/auth-providers/resolve-provider-visuals';

const {
	record,
	def,
} = defineProps<{
	def: AuthProviderDefinition | undefined;
	/** Admin record carrying per-provider icon/color overrides; preset def is the fallback. */
	record?: Pick<WireAuthProviderAdminRecord, 'icon' | 'iconColor'>;
}>();

const colorMode = useColorMode();
const visuals = computed(() =>
	resolveProviderVisuals(record, def, colorMode.value === 'dark'),
);
</script>

<template>
	<DIcon
		:name="visuals.iconName"
		:style="visuals.iconColor ? { color: visuals.iconColor } : undefined"
	/>
</template>
